<template>
  <fragment>
    <nav class="navbar menu-bar navbar-default" role="navigation" id="common-nav">
      <div class="content">
        <div class="container">
          <!-- Brand and toggle get grouped for better mobile display -->
          <div class="navbar-header">
           <div v-if="$cookie.get('username')" style="color:#ffffff;position:fixed;right:50px" class="sp">
              <span style="margin-top:-3px" class="icon user-small-red"></span>
              <a id="usernameSp"  href="/account" style="margin-left:3px;color:#ffffff">{{$cookie.get('username')}}</a>
               <span class="icon user-small-logout ic_display_name"   @click="changeDisplayName()" style="background-image:url(https://bi-winning.org/assets/img/ic_hide_name.png);"></span>
            </div>
            <button type="button" class="navbar-toggle toggler" data-toggle-target=".page-content"
              data-toggle-class="show-mobile-menu" id="menu">
              <span class="sr-only">Toggle navigation</span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
            </button>

            <router-link to="/" class="logo">
              <img src="@/assets/images/logo.png">
            </router-link>
          </div>
          <div class="menu-bar-menu-wrapper navbar-collapse" id="main-menu">
            <div class="menu-mobile-wrapper">
              <ul class="menu-bar-menu nav navbar-nav navbar-right">

              <div v-if="$cookie.get('userID')" class="login-icon sp">
                   <span class="icon user-small-red"></span>
                   <a id="usernameSp1" href="/account" class="highlight">{{$cookie.get('username')}}</a>
              </div>

                <li class="" onclick="location='/'">
                  <span class="main-menu-toggle-label">
                    <router-link to="/">{{$t('general.home')}}</router-link>
                  </span>
                </li>

<!-- 
                 <li  class="dropdown trade-menu-toggle-bookmark" data-toggle-target=".trade-menu-toggle-bookmark">
                  <span class="main-menu-toggle-label">
                    <a href="javascript:void(0);">{{$t('general.banking')}}</a>
                    <span class="icon drop-down dropdown-toggle"></span>
                  </span>
                  <ul class="dropdown-menu">
                    <li><router-link to="/transaction">{{$t('general.transaction')}}</router-link></li>
                    <li><router-link to="/deposit">{{$t('general.deposit')}}</router-link></li>
                    <li><router-link to="/withdraw">{{$t('general.widthdraw')}}</router-link></li>
                  </ul>
                </li>

 -->
                
                <li onclick="location='/trading'" class="dropdown trade-menu-toggle-bookmark sp" data-toggle-target=".trade-menu-toggle-bookmark">
                  <span class="main-menu-toggle-label" >
                    <a href="/trading">{{$t('general.trade')}}</a>
                  </span>
                </li>

                <li class="dropdown trade-menu-toggle-bookmark" data-toggle-target=".trade-menu-toggle-bookmark">
                  <span class="main-menu-toggle-label">
                    <a href="javascript:void(0);">{{$t('general.trade-introduce')}}</a>
                    <span class="icon drop-down dropdown-toggle"></span>
                  </span>
                  <ul class="dropdown-menu">
                   <!-- <li><a href="#">Trade Area</a></li>
                    <li><router-link to="/trade/trading-platforms">{{$t('general.trading-platforms')}}</router-link></li>
                    <li><router-link to="/trade/option-types">{{$t('general.option-types')}}</router-link></li> -->
                    <li><router-link to="/trade/trading-platforms">{{$t('general.trading-platforms')}}</router-link></li>
               <!-- <li><router-link to="/trade/option-types">{{$t('general.option-types')}}</router-link></li>-->
                   <li><router-link to="/trade/trade-conditions">{{$t('general.trading-conditions')}}</router-link></li>
                   <li><a href="/asset" replace >{{$t('general.option-schedule')}}</a></li>
                    <!-- <li><router-link to="/trade/expiry-rates">{{$t('general.expiry-rates')}}</router-link></li> -->
                  </ul>
                </li>
                <li class="dropdown highlow-menu-toggle-bookmark" data-toggle-target=".highlow-menu-toggle-bookmark">
                  <span class="main-menu-toggle-label">
                    <a href="javascript:void(0);">{{$t('bi-winning')}}</a>
                    <span class="icon drop-down dropdown-toggle"></span>
                  </span>
                  <ul class="dropdown-menu">
                    <li><router-link to="/overview">{{$t('general.bi-winning-overview')}}</router-link></li>
                   <!-- <li><router-link to="/why-trade">{{$t('general.why-trade')}}</router-link></li>-->
                    <li><router-link to="/banking">{{$t('general.banking')}}</router-link></li>
                   <li><router-link to="/about-company">{{$t('general.company1')}}</router-link></li>
                   <li><router-link to="/affiliate">{{$t('general.affiliate')}}</router-link></li>

                   <!-- <li><router-link to="/points">{{$t('general.points')}}</router-link></li>
                    <li><router-link to="/company">{{$t('general.company')}}</router-link></li> -->
                    <!--<li><router-link to="/help-and-support">{{$t('general.help-and-support')}}</router-link></li>-->
                  </ul>
                </li>
                <li class="dropdown resources-menu-toggle-bookmark" data-toggle-target=".resources-menu-toggle-bookmark">
                  <span class="main-menu-toggle-label">
                    <a href="javascript:void(0);">{{$t('general.resources')}}</a>
                    <span class="icon drop-down dropdown-toggle"></span>
                  </span>
                  <ul class="dropdown-menu">
                   <!-- <li><router-link to="/resources/overview">{{$t('general.resources-overview')}}</router-link></li> -->
                   <!-- <li><router-link to="/resources/faq">{{$t('general.faq')}}</router-link></li>-->
                    <li><a href="/trading">{{$t('general.quick-demo')}}</a> </li>
                   <li><router-link to="/faq">{{$t('general.faq')}}</router-link></li>

<!-- 
                    <li><router-link to="#">Platform Walk-through</router-link></li>
                    <li><router-link to="#">Video Training</router-link></li>
                    <li><router-link to="#"> Options Glossary </router-link></li>
 -->
                  </ul>
                </li>

                <li class="signup-menu-toggle-bookmark">
                  <span class="main-menu-toggle-label">
                    <a href="/#/demo" >{{$t('general.demo')}}</a>
                  </span>
                </li>

                <li v-if="!$cookie.get('userID')" class="signup-menu-toggle-bookmark">
                  <span class="main-menu-toggle-label">
                    <a class="signup" href="/register" >{{$t('general.sign-up')}}</a>
                  </span>
                </li>


              </ul>
               <span class="status-bar-user" >
                <!-- <a v-if="!$cookie.get('userID')" href="/register" class="btn hidden-sm hidden-md hidden-lg"> {{$t('claim-cash-back')}} </a>-->
                <span v-if="!$cookie.get('userID')" class="status-bar-greetings">
                  <span class="icon user-small-red"></span>
                  <a href="/login"> {{$t('general.log-in')}} </a>
                </span>

                 <span v-if="$cookie.get('userID')" class="status-bar-greetings">
                  <span class="icon user-small-logout" ></span>
                        <a  href="https://bpw.bi-winning.org/index/sign-out?redirectUrl=https://www.bi-winning.org/"   class="highlight" >{{$t('general.logout')}}</a>
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>

    </nav>
    <div class="dropdown-mega-menu trade-menu-toggle-bookmark">
      <div class="container content">
        <div class="row">
          <div class="col-sm-6 col-lg-7 dropdown-mega-menu--cta">

            <a href="/register" class="dropdown-mega-menu--attention-grabber" id="quick-demo-link">
              <img data-src="@assets/images/platform-on-yellow.jpg" class="illustration" id="quick-demo-link--img" src="@/assets/images/platform-on-yellow.jpg">
              <img data-src="@assets/images/platform-on-yellow-hover.jpg" class="illustration" id="quick-demo-link--img--hover" src="@/assets/images/platform-on-yellow-hover.jpg">
              <div class="dropdown-mega-menu--attention-grabber--heading mti_font_element">
                <span v-html="$t('general.try-bi-winning')"></span> <span class="quick-demo-link-arrow mti_font_element"></span> 
              </div>
            </a>
                          
          </div>
          <div class="col-sm-6 col-lg-5 clearfix dropdown-mega-menu--links">
            <ul>
              <li>
                <!-- <a href="//en.trade.highlow.net/" id="trade-area-link">
                  <small> ACCESS THE </small>
                  <em> TRADE AREA </em>
                  <div class="btn-negative btn btn-extruded"> TRADE NOW </div>
                </a> -->
              </li>
            </ul>
            <ul>
              <li><router-link to="/trade/trading-platforms">{{$t('general.trading-platforms')}}</router-link></li>
               <!-- <li><router-link to="/trade/option-types">{{$t('general.option-types')}}</router-link></li>-->
              <li><router-link to="/trade/trade-conditions">{{$t('general.trading-conditions')}}</router-link></li>
              <li><a href="/asset" replace >{{$t('general.option-schedule')}}</a></li>
              <!-- <li><router-link to="/trade/expiry-rates">{{$t('general.expiry-rates')}}</router-link></li> -->
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="dropdown-mega-menu highlow-menu-toggle-bookmark">
      <div class="container content">
        <div class="row">
          <div class="col-sm-5 col-md-6 col-lg-7 dropdown-mega-menu--cta">
            <div class="dropdown-mega-menu--attention-grabber">
              <img data-src="@/assets/images/money-stack.jpg" class="illustration"
                src="@/assets/images/money-stack.jpg">

              <div class="dropdown-mega-menu--attention-grabber--heading">
                <span v-html="$t('general.mega-sign-up')"></span>
                <a href="/login" class="btn-negative btn btn-extruded">GO</a>
              </div>
            </div>
          </div>
          <div class="col-sm-7 col-md-6 col-lg-5 clearfix dropdown-mega-menu--links">
            <ul>
              <li><router-link to="/overview">{{$t('general.bi-winning-overview')}}</router-link></li>
              <!--<li><router-link to="/why-trade">{{$t('general.why-trade')}}</router-link></li>-->
              <li><router-link to="/banking">{{$t('general.banking')}}</router-link></li>
               <li><router-link to="/about-company">{{$t('general.company1')}}</router-link></li>
              <li><router-link to="/affiliate">{{$t('general.affiliate')}}</router-link></li>
               <!-- <li><router-link to="/points">{{$t('general.bi-winning-points')}}</router-link></li> -->
            </ul>
            <ul>
               <!--<li><router-link to="/company">{{$t('general.company')}}</router-link></li> -->
              <!--<li><router-link to="/help-and-support">{{$t('general.help-and-support')}}</router-link></li>-->
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="dropdown-mega-menu resources-menu-toggle-bookmark">
      <div class="container content">
        <div class="row">
          <div class="col-sm-5 col-md-6 col-lg-7 dropdown-mega-menu--cta">
            <div class="dropdown-mega-menu--attention-grabber">
              <div class="dropdown-mega-menu--attention-grabber--heading">
                <span v-html="$t('general.mega-search')"></span>
              </div>
              <SearchForm/>
            </div>
          </div>
          <div class="col-sm-7 col-md-6 col-lg-5 clearfix dropdown-mega-menu--links">
            <ul>
             <!-- <li><router-link to="/resources/overview">{{$t('general.resources-overview')}}</router-link></li> -->
              <li><a href="/trading">{{$t('general.quick-demo')}}</a> </li>
              <li><router-link to="/faq">{{$t('general.faq')}}</router-link></li>
               <li><a href="https://twitter.com/BIWINNING1" target="_blank">公式Twitter</a> </li>
              <!-- <li><router-link to="#">Platform Walk-through</router-link></li> -->
            </ul>
            <!-- <ul>
              <li><router-link to="#">{{$t('general.video')}}</router-link></li>
               <li><router-link to="#"> Options Glossary </router-link></li> 
              <li><a>&nbsp; </a></li>
            </ul>-->
          </div>
        </div>
      </div>
    </div>

  </fragment>

</template>

<script>
import SearchForm from './SearchForm.vue'
export default {
  components: {SearchForm},
  data(){
    return {
      isFirst:true
    }
  },
  watch: {
        '$route': function (from, to) {
          console.log("sdfsfsdfsdsfsdfsdf",location.href)
           if(!this.isFirst&&location.href.indexOf("contact-us")==-1){
             document.getElementById("menu").click(); // Click on the checkbox
           }
           this.isFirst=false;
           setTimeout(function(){ 
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
           }, 100);
         }   
    },
        mounted: function () {
                this.$nextTick(function () {
                        this.setName();
                })
        },
        methods: {
                setName() {
                        var pairs = document.cookie.split(";");
                        var cokie = {};
                        for (var i = 0; i < pairs.length; i++) {
                                var pair = pairs[i].split("=");
                                cokie[(pair[0] + '').trim()] = pair.slice(1).join('=');
                        }
                        if (cokie && cokie.username) {
                                if (document.getElementById("username")) {
                                        document.getElementById("username").innerHTML = localStorage.getItem("name") == "1" ? "*******" : decodeURI(cokie.username)
                                }
                                if (document.getElementById("usernameSp")) {
                                        document.getElementById("usernameSp").innerHTML = localStorage.getItem("name") == "1" ? "*******" : decodeURI(cokie.username)
                                }

                                if (document.getElementById("usernameSp1")) {
                                        document.getElementById("usernameSp1").innerHTML = localStorage.getItem("name") == "1" ? "*******" : decodeURI(cokie.username)
                                }
                        }
                        const elements = document.getElementsByClassName("ic_display_name");
                        if (elements && elements.length > 0) {
                                const url = localStorage.getItem("name") == "1" ? "https://bi-winning.org/assets/img/ic_show_name2.png" : "https://bi-winning.org/assets/img/ic_hide_name.png"
                                elements[0].style.backgroundImage = `url('${url}')`;
                        }
                },
                changeDisplayName() {
                        if (localStorage.getItem("name") != "1") {
                                localStorage.setItem("name", "1")
                        } else {
                                localStorage.setItem("name", "")
                        }
                        this.setName()
                }

        }
}
  
</script>